"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var busy_indicator_1 = require("../busy-indicator");
var vdl_prefix_1 = require("../util/vdl-prefix");
var _1 = require("../util/_");
var Button = /** @class */function (_super) {
  __extends(Button, _super);
  function Button() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Button.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      buttonStyle = _b.buttonStyle,
      type = _b.type,
      busy = _b.busy,
      children = _b.children,
      disabled = _b.disabled,
      onClick = _b.onClick;
    var customProps = _1.omit(this.props, Object.keys(Button.propTypes));
    var buttonClasses = (_a = {}, _a[vdl_prefix_1.vdlPrefix('button')] = true, _a[vdl_prefix_1.vdlPrefix("button--" + buttonStyle)] = true, _a[vdl_prefix_1.vdlPrefix('button--busy')] = busy, _a);
    return react_1.default.createElement("button", __assign({}, customProps, {
      type: type,
      disabled: disabled,
      "aria-disabled": disabled,
      className: classnames_1.classNames(className, buttonClasses),
      onClick: onClick
    }), react_1.default.createElement("span", {
      className: vdl_prefix_1.vdlPrefix('button__container')
    }, children), this.props.busy ? react_1.default.createElement(busy_indicator_1.BusyIndicator, {
      size: "sm"
    }) : undefined);
  };
  Button.propTypes = {
    buttonStyle: prop_types_1.default.oneOf(['primary', 'secondary', 'danger', 'link']),
    type: prop_types_1.default.string,
    busy: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    className: prop_types_1.default.string,
    children: prop_types_1.default.node,
    onClick: prop_types_1.default.func
  };
  Button.defaultProps = {
    buttonStyle: 'primary',
    type: 'button',
    busy: false,
    disabled: false
  };
  return Button;
}(react_1.default.Component);
exports.Button = Button;